module.exports = __webpack_public_path__ + "static/flags/CL-5e0f3a08c8c34de78a056006f87bb116.gif";